var map = {
	"./basic-modal.vue": 4864,
	"./cart-additional-product.vue": 6395,
	"./cart-page.vue": 5968,
	"./cart-preview.vue": 662,
	"./collection-filter-item.vue": 1865,
	"./collection-filter.vue": 1861,
	"./collection-filters.vue": 1302,
	"./collection-pagination.vue": 6888,
	"./collection-preview-product.vue": 2645,
	"./collection-preview.vue": 2729,
	"./collection-product-swatch.vue": 8640,
	"./collection-product-swatches.vue": 8807,
	"./collection-product.vue": 6571,
	"./collection-products.vue": 9313,
	"./collection-selected-tags.vue": 7052,
	"./collection.vue": 5285,
	"./config.vue": 709,
	"./expandable.vue": 1951,
	"./image-swiper.vue": 3154,
	"./img-yay.vue": 1540,
	"./map-box.vue": 1444,
	"./navbar-search.vue": 2498,
	"./newsletter-popup.vue": 8813,
	"./product-add-to-cart.vue": 4758,
	"./product-addon-blue-blocker.vue": 5463,
	"./product-addon-clip.vue": 7145,
	"./product-addon-lens.vue": 5703,
	"./product-addon-monogram.vue": 7888,
	"./product-addons.vue": 6563,
	"./product-detail-size.vue": 1414,
	"./product-detail.vue": 8387,
	"./product-details.vue": 7064,
	"./product-images.vue": 7043,
	"./product-model-photos.vue": 2854,
	"./product-price.vue": 4417,
	"./product-related-products.vue": 6273,
	"./product-variant-selector.vue": 60,
	"./product-variant.vue": 7828,
	"./product-variants.vue": 8578,
	"./product.vue": 5475,
	"./renderless/addresses.vue": 2054,
	"./renderless/index.vue": 5026,
	"./renderless/navbar.vue": 9501,
	"./renderless/template-switch.vue": 7922,
	"./search-box-input.vue": 6703,
	"./search-box-results.vue": 1423,
	"./search-box.vue": 2416,
	"./sidebar-link.vue": 100,
	"./sidebar.vue": 2615,
	"./svg-care.vue": 9131,
	"./svg-face.vue": 6988,
	"./svg-materials.vue": 4552,
	"./svg-search.vue": 9527,
	"./svg-wave-animated.vue": 6092,
	"./svg-x.vue": 7777,
	"./tab.vue": 3125,
	"./tabs.vue": 4442,
	"./video-player.vue": 2844,
	"./view-on-map.vue": 2784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1904;